import React from "react";
import { Button, Card, CardBody, Input } from 'reactstrap';
import { ModalInfoAnlyte } from "../../../components/infoAnalytes/ModalInfoAnlyte";
import { useInfoAnalytes } from "../../../hooks/analytes/useInfoAnalytes";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexInfoAnalytes = () => {

    const {
        analytes, method, validaciones,
        name, code, is_interfaced,
        handleInputChange, loading,
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        exportExcel, handleSearch,
        handleUpdate, saveUpdate
    } = useInfoAnalytes();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_info_analyte)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>
            </div>
        );
    };

    const header = (
        <div className="d-flex align-items-center justify-content-between w-100" style={{ gap: '1rem', marginBottom: '1rem' }}>
            <Button
                color="success"
                onClick={exportExcel}
                size="sm"
                title="Exportar a Excel"
                style={{ 
                    padding: "2px 6px", 
                    height: "28px", 
                    fontSize: "0.8rem", 
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <i className="pi pi-file-excel me-1" />
            </Button>

            <Input
                placeholder='Busqueda...'
                className='form-control form-control-sm'
                onChange={handleSearch}
                style={{ maxWidth: '450px', width: '100%' }}
            />
        </div>
    );


    return (
        <>
            <Card>
                <CardBody className="p-1">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <div className="ribbon ribbon-clip ribbon-primary" style={{ marginBottom: '1rem' }}>
                               Listado de analitos
                            </div>
                        </div>
                        
                        <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={handleCreate}>
                            <span className="fa fa-plus-circle"></span>
                        </Button>
                    </div>


                    <div className="table-responsive">
                        <DataTable
                            value={analytes}
                            paginator 
                            rows={10} 
                            className="data-table p-datatable-striped p-datatable-sm"
                            emptyMessage={
                                <div className="text-center">
                                    <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                    <br />
                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                        Sin Analitos.
                                    </p>
                                </div>
                            }
                            rowsPerPageOptions={[10, 50, 100]}
                            responsiveLayout="scroll"
                            header={header}
                        >
                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column field="code" header="Clave" sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column field="is_interfaced" header="Interfazado" body={(rowData) => rowData.is_interfaced ? "Sí" : "No"} sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />
                        </DataTable>
                    </div>
                </CardBody>
            </Card>
            <ModalInfoAnlyte
                {...{
                    modal, modalTitle, toggle, method,
                    validaciones,
                    name, code, is_interfaced,
                    handleInputChange, loading,
                    saveCreate,
                    saveUpdate,
                }}
            />
            <br />
        </>
    );
};
